import { render, staticRenderFns } from "./BusinessParticulars.vue?vue&type=template&id=9064dd06&scoped=true&"
import script from "./BusinessParticulars.vue?vue&type=script&lang=js&"
export * from "./BusinessParticulars.vue?vue&type=script&lang=js&"
import style0 from "./BusinessParticulars.vue?vue&type=style&index=0&id=9064dd06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9064dd06",
  null
  
)

export default component.exports